module.exports = "/images/marking-icon-gallery_new.svg?afd6eb821514b1b1c5f1133abaccc539";